<!-- new ionic home card skeleton -->
@if (type && type == 'home') {
  <div>
    <ion-item class="top-home-page" lines="none">
      <ion-avatar slot="start">
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-avatar>
      <ion-label>
        <h3>
          <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
        </h3>
      </ion-label>
      <ion-avatar slot="end" class="bell-icon">
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-avatar>
    </ion-item>
    <div class="slider">
      <ion-thumbnail slot="start" class="home-card-skeleton-1">
        <ion-skeleton-text animated class="home-card-skeleton-text"></ion-skeleton-text>
      </ion-thumbnail>
      <ion-thumbnail slot="start" class="home-card-skeleton-2">
        <ion-skeleton-text animated class="home-card-skeleton-text-2"></ion-skeleton-text>
      </ion-thumbnail>
    </div>
    <ion-skeleton-text animated class="goal-skeleton"></ion-skeleton-text>
  </div>
}
<!--new syndicate skeleton loader-->
@if (type && type == 'syndicate') {
  <div>
    <ion-item class="top-home-page syndicate-top" lines="none">
      <ion-skeleton-text animated style="width: 50%; height: 4vh"></ion-skeleton-text>
      <ion-avatar slot="end" class="bell-icon">
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-avatar>
    </ion-item>
    <p class="for-alignment-skeleton">
      <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
    </p>
    <p class="for-alignment-skeleton">
      <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
    </p>
    <ion-skeleton-text animated class="for-alignment-skeleton extra-text"> </ion-skeleton-text>
    <ion-item lines="none">
      <ion-skeleton-text animated class="extras-section-skeleton"></ion-skeleton-text>
      <ion-skeleton-text animated class="extras-section-skeleton"></ion-skeleton-text>
    </ion-item>
    <ion-skeleton-text animated class="syndicate-card-skeleton"> </ion-skeleton-text>
  </div>
}

<!--new game page skeleton loader-->

@if (type && type == 'loadingUser') {
  <div>
    <ion-item style="padding-top: 3vh; background-color: #fff" lines="none">
      <ion-skeleton-text animated style="width: 45vw; height: 6vh; margin-bottom: 15px"></ion-skeleton-text>
    </ion-item>
  </div>
}

@if (type && type == 'loadingadventures') {
  <div>
    <ion-item
    style="
      position: absolute;
      top: 0;
      display: block;
      width: 100%;
      min-height: 500px;
      height: 500px;
      padding: 10px 0px;
      background-color: #fff;
    "
      lines="none"
      >
      <ion-skeleton-text animated style="width: 50%; height: 4vh"></ion-skeleton-text>
      <ion-avatar slot="end" class="bell-icon">
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-avatar>
    </ion-item>
    <div style="background-color: #fff; margin-bottom: 10px; padding-bottom: 50px; padding-top: 15px">
      <ion-item class="top-home-page game-user" lines="none">
        <ion-skeleton-text animated style="width: 50%; height: 3vh"></ion-skeleton-text>
      </ion-item>
      <div class="slidebox" lines="none">
        <ion-skeleton-text animated class="img-skeleton"></ion-skeleton-text>
        <ion-skeleton-text animated class="img-skeleton"></ion-skeleton-text>
        <ion-skeleton-text animated class="img-skeleton"></ion-skeleton-text>
        <ion-skeleton-text animated class="img-skeleton"></ion-skeleton-text>
      </div>
      <div class="slidetext" lines="none">
        <ion-skeleton-text animated class="text-skeleton"></ion-skeleton-text>
        <ion-skeleton-text animated class="text-skeleton"></ion-skeleton-text>
        <ion-skeleton-text animated class="text-skeleton"></ion-skeleton-text>
        <ion-skeleton-text animated class="text-skeleton"></ion-skeleton-text>
      </div>
    </div>
    <ion-list>
      <div>
        <ion-skeleton-text
          animated
          style="width: 35%; height: 3vh; margin-left: 20px; margin-bottom: 10px; margin-top: 15px"
        ></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 80%; height: 2vh; margin-left: 20px; margin-bottom: 20px">
        </ion-skeleton-text>
      </div>
      <ion-item>
        <ion-thumbnail slot="start">
          <ion-skeleton-text animated></ion-skeleton-text>
        </ion-thumbnail>
        <ion-label>
          <h3>
            <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
          </h3>
          <p>
            <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
          </p>
          <p>
            <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
          </p>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-thumbnail slot="start">
          <ion-skeleton-text animated></ion-skeleton-text>
        </ion-thumbnail>
        <ion-label>
          <h3>
            <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
          </h3>
          <p>
            <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
          </p>
          <p>
            <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
          </p>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-thumbnail slot="start">
          <ion-skeleton-text animated></ion-skeleton-text>
        </ion-thumbnail>
        <ion-label>
          <h3>
            <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
          </h3>
          <p>
            <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
          </p>
          <p>
            <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
          </p>
        </ion-label>
      </ion-item>
    </ion-list>
    <div style="padding-bottom: 15px">
      <div class="advheader">
        <ion-skeleton-text animated="" style="width: 50%; height: 3vh; margin-bottom: 15px"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 75%; height: 2vh"></ion-skeleton-text>
      </div>
      <div class="advbox" lines="none">
        <ion-skeleton-text animated="" class="adv-skeleton"></ion-skeleton-text>
        <ion-skeleton-text animated class="adv-skeleton2"></ion-skeleton-text>
      </div>
    </div>
  </div>
}

@if (type && type == 'loadingcommon') {
  <div>
    <ion-list>
      <div>
        <ion-skeleton-text
          animated
          style="width: 35%; height: 3vh; margin-left: 20px; margin-bottom: 10px; margin-top: 15px"
        ></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 80%; height: 2vh; margin-left: 20px; margin-bottom: 20px">
        </ion-skeleton-text>
      </div>
      <ion-item>
        <ion-thumbnail slot="start">
          <ion-skeleton-text animated></ion-skeleton-text>
        </ion-thumbnail>
        <ion-label>
          <h3>
            <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
          </h3>
          <p>
            <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
          </p>
          <p>
            <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
          </p>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-thumbnail slot="start">
          <ion-skeleton-text animated></ion-skeleton-text>
        </ion-thumbnail>
        <ion-label>
          <h3>
            <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
          </h3>
          <p>
            <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
          </p>
          <p>
            <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
          </p>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-thumbnail slot="start">
          <ion-skeleton-text animated></ion-skeleton-text>
        </ion-thumbnail>
        <ion-label>
          <h3>
            <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
          </h3>
          <p>
            <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
          </p>
          <p>
            <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
          </p>
        </ion-label>
      </ion-item>
    </ion-list>
  </div>
}

<!--new store page skeleton loader-->

@if (type && type == 'storloading') {
  <div>
    <ion-item class="top-home-page syndicate-top" lines="none">
      <ion-skeleton-text animated style="width: 50%; height: 4vh"></ion-skeleton-text>
      <ion-avatar slot="end" class="bell-icon">
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-avatar>
    </ion-item>
    <ion-list-header>
      <ion-label>
        <ion-skeleton-text style="width: 73%; height: 20px"></ion-skeleton-text>
      </ion-label>
    </ion-list-header>
    <div lines="none" style="padding: 20px">
      <ion-skeleton-text animated style="height: 150px; border-radius: 10px"></ion-skeleton-text>
    </div>
    <ion-item>
      <ion-avatar slot="start">
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-avatar>
      <ion-label>
        <h3>
          <ion-skeleton-text animated style="width: 50%"> </ion-skeleton-text>
        </h3>
        <p>
          <ion-skeleton-text animated style="width: 80%"> </ion-skeleton-text>
        </p>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-avatar slot="start" class="md hydrated">
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-avatar>
      <ion-label>
        <h3>
          <ion-skeleton-text animated style="width: 50%"> </ion-skeleton-text>
        </h3>
        <p>
          <ion-skeleton-text animated style="width: 80%"> </ion-skeleton-text>
        </p>
      </ion-label>
    </ion-item>
    <div lines="none" style="height: 150px; display: flex; align-items: center; margin-left: 20px">
      <div style="display: block; width: 100%">
        <p>
          <ion-skeleton-text animated style="width: 40%; height: 20px"> </ion-skeleton-text>
        </p>
        <p>
          <ion-skeleton-text animated style="width: 50%; height: 16px"> </ion-skeleton-text>
        </p>
        <p>
          <ion-skeleton-text animated style="width: 61%; height: 16px"> </ion-skeleton-text>
        </p>
        <p>
          <ion-skeleton-text animated style="width: 30%"> </ion-skeleton-text>
        </p>
      </div>
    </div>
    <ion-item>
      <ion-avatar slot="start">
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-avatar>
      <ion-label>
        <h3>
          <ion-skeleton-text animated style="width: 50%"> </ion-skeleton-text>
        </h3>
        <p>
          <ion-skeleton-text animated style="width: 80%"> </ion-skeleton-text>
        </p>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-avatar slot="start">
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-avatar>
      <ion-label>
        <h3>
          <ion-skeleton-text animated style="width: 50%"> </ion-skeleton-text>
        </h3>
        <p>
          <ion-skeleton-text animated style="width: 80%"> </ion-skeleton-text>
        </p>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-avatar slot="start">
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-avatar>
      <ion-label>
        <h3>
          <ion-skeleton-text animated style="width: 50%"> </ion-skeleton-text>
        </h3>
        <p>
          <ion-skeleton-text animated style="width: 80%"> </ion-skeleton-text>
        </p>
      </ion-label>
    </ion-item>
  </div>
}

<!-- skeleton loader for social tab -->
@if (type && type == 'social') {
  <div>
    <ion-skeleton-text animated class="social-header"></ion-skeleton-text>
    <ion-skeleton-text animated class="social-cover"></ion-skeleton-text>
    <ion-avatar slot="" class="social-avatar">
      <ion-skeleton-text animated></ion-skeleton-text>
    </ion-avatar>
    <ion-skeleton-text animated class="social-username"></ion-skeleton-text>
    <ion-item lines="none" style="margin-top: 1.5vh">
      <div class="social-badge-area">
        <ion-skeleton-text animated class="social-badge"></ion-skeleton-text>
        <ion-skeleton-text animated class="social-badge-name"></ion-skeleton-text>
      </div>
      <div class="social-badge-area">
        <ion-skeleton-text animated class="social-badge"></ion-skeleton-text>
        <ion-skeleton-text animated class="social-badge-name"></ion-skeleton-text>
      </div>
      <div class="social-badge-area">
        <ion-skeleton-text animated class="social-badge"></ion-skeleton-text>
        <ion-skeleton-text animated class="social-badge-name"></ion-skeleton-text>
      </div>
      <div class="social-badge-area">
        <ion-skeleton-text animated class="social-badge"></ion-skeleton-text>
        <ion-skeleton-text animated class="social-badge-name"></ion-skeleton-text>
      </div>
    </ion-item>
    <div class="social-tab-group">
      <ion-skeleton-text animated class="social-mat-tabs"></ion-skeleton-text>
      <ion-skeleton-text animated class="social-mat-tabs"></ion-skeleton-text>
      <ion-skeleton-text animated class="social-mat-tabs"></ion-skeleton-text>
    </div>
  </div>
}
<!-- skeleton loader for social tab -->

<!-- skeleton loader for hero tab -->
@if (type && type == 'social-hero') {
  <div>
    <div class="social-sub-tab-group">
      <ion-skeleton-text animated></ion-skeleton-text>
      <ion-skeleton-text animated></ion-skeleton-text>
      <ion-skeleton-text animated></ion-skeleton-text>
      <ion-skeleton-text animated></ion-skeleton-text>
    </div>
    <div class="social-hero-area">
      <ion-skeleton-text animated class="hero-bg"></ion-skeleton-text>
      <ion-skeleton-text animated class="like-follow"></ion-skeleton-text>
    </div>
    <div class="gem-area">
      <ion-skeleton-text animated class="bg"></ion-skeleton-text>
      <ion-skeleton-text animated class="desc-1"></ion-skeleton-text>
      <ion-skeleton-text animated class="desc-2"></ion-skeleton-text>
      <ion-skeleton-text animated class="desc-3"></ion-skeleton-text>
      <ion-skeleton-text animated class="desc-4"></ion-skeleton-text>
      <div class="gem-section">
        <div class="gem-sec-1">
          <div class="gem-rank">
            <ion-skeleton-text animated class="b1"></ion-skeleton-text>
            <ion-skeleton-text animated class="b2"></ion-skeleton-text>
            <ion-skeleton-text animated class="b3"></ion-skeleton-text>
          </div>
          <div class="gem-box">
            <ion-skeleton-text animated class="b4"></ion-skeleton-text>
            <ion-skeleton-text animated class="b5"></ion-skeleton-text>
          </div>
        </div>
        <div class="gem-sec-2">
          <ion-skeleton-text animated class="b6"></ion-skeleton-text>
          <ion-skeleton-text animated class="b7"></ion-skeleton-text>
        </div>
      </div>
    </div>
  </div>
}
<!-- skeleton loader for hero tab -->
<!-- stream -->
@if (type && type == 'stream') {
  <div class="loading">
    <ion-skeleton-text animate class="str-comment"></ion-skeleton-text>
    <div class="str-filter">
      <ion-skeleton-text animate class="filter"></ion-skeleton-text>
      <ion-skeleton-text animate class="round str-1"></ion-skeleton-text>
      <ion-skeleton-text animate class="round str-2"></ion-skeleton-text>
      <ion-skeleton-text animate class="round str-3"></ion-skeleton-text>
      <ion-skeleton-text animate class="round str-4"></ion-skeleton-text>
    </div>
    <div class="search-hash">
      <ion-skeleton-text animate class="search"></ion-skeleton-text>
      <ion-skeleton-text animate class="hash"></ion-skeleton-text>
    </div>
    <div class="stream-profile">
      <ion-avatar slot="start">
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-avatar>
      <h3>
        <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
      </h3>
    </div>
    <ion-skeleton-text animated style="width: 80%; margin-left: 3vh"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 60%; margin-left: 3vh"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 70%; margin-left: 3vh"></ion-skeleton-text>
    <ion-skeleton-text
      animated
      style="width: 94%; margin: 2vh auto; height: 25vh; border-radius: 10px"
    ></ion-skeleton-text>
  </div>
}
<!-- new ionic home-feed skeleton -->
@if (type && type == 'home-feed') {
  <div>
    <ion-item class="home-feed" lines="none">
      <ion-avatar slot="start">
        <ion-skeleton-text [animated]="true"></ion-skeleton-text>
      </ion-avatar>
      <ion-label>
        <h3>
          <ion-skeleton-text [animated]="true" style="width: 80%"></ion-skeleton-text>
        </h3>
        <p>
          <ion-skeleton-text [animated]="true" style="width: 60%"></ion-skeleton-text>
        </p>
        <p>
          <ion-skeleton-text [animated]="true" style="width: 30%"></ion-skeleton-text>
        </p>
      </ion-label>
    </ion-item>
    <ion-thumbnail slot="start" class="home-feed-card-skeleton-1">
      <ion-skeleton-text animated class="home-card-skeleton-text"></ion-skeleton-text>
    </ion-thumbnail>
    <ion-item class="home-feed" lines="none">
      <ion-avatar slot="start">
        <ion-skeleton-text [animated]="true"></ion-skeleton-text>
      </ion-avatar>
      <ion-label>
        <h3>
          <ion-skeleton-text [animated]="true" style="width: 80%"></ion-skeleton-text>
        </h3>
        <p>
          <ion-skeleton-text [animated]="true" style="width: 60%"></ion-skeleton-text>
        </p>
      </ion-label>
    </ion-item>
    <ion-thumbnail slot="start" class="home-feed-card-skeleton-1">
      <ion-skeleton-text animated class="home-card-skeleton-text"></ion-skeleton-text>
    </ion-thumbnail>
    <ion-item class="home-feed" lines="none">
      <ion-avatar slot="start">
        <ion-skeleton-text [animated]="true"></ion-skeleton-text>
      </ion-avatar>
      <ion-label>
        <h3>
          <ion-skeleton-text [animated]="true" style="width: 80%"></ion-skeleton-text>
        </h3>
        <p>
          <ion-skeleton-text [animated]="true" style="width: 60%"></ion-skeleton-text>
        </p>
      </ion-label>
    </ion-item>
  </div>
}

<!-- new Game-feed -->

@if (type && type == 'game-feed-loading') {
  <div>
    <div style="padding-bottom: 15px;">
      <div class="advheader">
        <ion-skeleton-text animated="" style="width: 50%;height: 3vh; margin-bottom: 15px;"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 75%; height: 2vh;"></ion-skeleton-text>
      </div>
      <div class="advbox" lines="none">
        <ion-skeleton-text animated="" class="adv-skeleton"></ion-skeleton-text>
        <ion-skeleton-text animated class="adv-skeleton2"></ion-skeleton-text>
      </div>
    </div>
    <div style="background-color: #fff;margin-bottom: 10px;padding-bottom: 50px;padding-top: 15px;">
      <ion-item class="top-home-page game-user" lines="none">
        <ion-skeleton-text animated style="width: 50%; height: 3vh;"></ion-skeleton-text>
      </ion-item>
      <div class="slidebox" lines="none">
        <ion-skeleton-text animated class="img-skeleton"></ion-skeleton-text>
        <ion-skeleton-text animated class="img-skeleton"></ion-skeleton-text>
        <ion-skeleton-text animated class="img-skeleton"></ion-skeleton-text>
        <ion-skeleton-text animated class="img-skeleton"></ion-skeleton-text>
      </div>
      <div class="slidetext" lines="none">
        <ion-skeleton-text animated class="text-skeleton"></ion-skeleton-text>
        <ion-skeleton-text animated class="text-skeleton"></ion-skeleton-text>
        <ion-skeleton-text animated class="text-skeleton"></ion-skeleton-text>
        <ion-skeleton-text animated class="text-skeleton"></ion-skeleton-text>
      </div>
    </div>
    <ion-list>
      <div>
        <ion-skeleton-text animated
        style="width: 35%;height: 3vh;margin-left: 20px;margin-bottom: 10px;margin-top: 15px;"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 80%;height: 2vh;margin-left: 20px;margin-bottom: 20px;">
        </ion-skeleton-text>
      </div>
      <ion-item>
        <ion-thumbnail slot="start">
          <ion-skeleton-text animated></ion-skeleton-text>
        </ion-thumbnail>
        <ion-label>
          <h3>
            <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
          </h3>
          <p>
            <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
          </p>
          <p>
            <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
          </p>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-thumbnail slot="start">
          <ion-skeleton-text animated></ion-skeleton-text>
        </ion-thumbnail>
        <ion-label>
          <h3>
            <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
          </h3>
          <p>
            <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
          </p>
          <p>
            <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
          </p>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-thumbnail slot="start">
          <ion-skeleton-text animated></ion-skeleton-text>
        </ion-thumbnail>
        <ion-label>
          <h3>
            <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
          </h3>
          <p>
            <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
          </p>
          <p>
            <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
          </p>
        </ion-label>
      </ion-item>
    </ion-list>
  </div>
}

<!-- [GF] Skeleton Fortune Missions -->
@if (type && type == 'missions-cards-skeleton') {
  <div style="padding: 0px 15px">
    <div class="missions-cards-title">
      <ion-skeleton-text animated></ion-skeleton-text>
    </div>
    <div class="discover-card-area missions-big-card">
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
    </div>
    <div class="missions-cards-title0">
      <ion-skeleton-text animated class="big-title1"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-ttile2"></ion-skeleton-text>
    </div>
    <div class="missions-cards-title1">
      <ion-skeleton-text animated></ion-skeleton-text>
      <ion-skeleton-text animated class="sub"></ion-skeleton-text>
    </div>
    <div class="discover-two-cards-area missions-two-cards-area">
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
    </div>
  </div>
}
<!-- [GF] Skeleton Fortune Missions -->

<!-- [GF] Skeleton Game Trending & Discover -->
@if (type && type == 'trending') {
  <div>
    <div class="trending-cards-title">
      <ion-skeleton-text animated></ion-skeleton-text>
    </div>
    <div class="lotteries-cards-title1">
      <ion-skeleton-text animated></ion-skeleton-text>
      <ion-skeleton-text animated class="sub"></ion-skeleton-text>
    </div>
    <div class="discover-two-cards-area">
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
    </div>
    <div class="lotteries-cards-title1">
      <ion-skeleton-text animated></ion-skeleton-text>
      <ion-skeleton-text animated class="sub"></ion-skeleton-text>
    </div>
    <div class="discover-two-cards-area">
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
    </div>
  </div>
}
<!-- [GF] Skeleton Game Trending & Discover -->

<!-- [GF] Skeleton Fortune Missions -->
@if (type && type == 'missions-cards-skeleton') {
  <div style="padding: 0px 15px">
    <div class="missions-cards-title">
      <ion-skeleton-text animated></ion-skeleton-text>
    </div>
    <div class="discover-card-area missions-big-card">
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
    </div>
    <div class="missions-cards-title0">
      <ion-skeleton-text animated class="big-title1"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-ttile2"></ion-skeleton-text>
    </div>
    <div class="missions-cards-title1">
      <ion-skeleton-text animated></ion-skeleton-text>
      <ion-skeleton-text animated class="sub"></ion-skeleton-text>
    </div>
    <div class="discover-two-cards-area missions-two-cards-area">
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
    </div>
  </div>
}
<!-- [GF] Skeleton Fortune Missions -->

<!-- [GF] Skeleton Fortune Discover -->
@if (type && type == 'lotteries-cards-skeleton') {
  <div>
    <div class="lotteries-cards-title">
      <ion-skeleton-text animated></ion-skeleton-text>
      <ion-skeleton-text animated class="sub"></ion-skeleton-text>
    </div>
    <div class="discover-card-area">
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
    </div>
    <div class="lotteries-cards-title1">
      <ion-skeleton-text animated></ion-skeleton-text>
      <ion-skeleton-text animated class="sub"></ion-skeleton-text>
    </div>
    <div class="discover-two-cards-area">
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
    </div>
    <div class="lotteries-cards-title2">
      <ion-skeleton-text animated></ion-skeleton-text>
      <ion-skeleton-text animated class="sub"></ion-skeleton-text>
    </div>
    <div class="discover-two-cards-area">
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
    </div>
  </div>
}
<!-- [GF] Skeleton Fortune Discover -->

<!-- [GF] Skeleton Game leaderboard -->
@if (type && type == 'leaderboard') {
  <div>
    <div class="trending-cards-title">
      <ion-skeleton-text animated></ion-skeleton-text>
    </div>
    <div class="leaderboard-cards-title1">
      <ion-skeleton-text animated></ion-skeleton-text>
    </div>
    <div class="leaderboard-cards-title2">
      <ion-skeleton-text animated class="sub"></ion-skeleton-text>
    </div>
    <div class="discover-two-cards-area1">
      <ion-skeleton-text animated class="leader-big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="leader-big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="leader-big-card"></ion-skeleton-text>
    </div>
    <div class="leaderboard-cards-title3">
      <ion-skeleton-text animated></ion-skeleton-text>
    </div>
    <div class="leaderboard-cards-title1">
      <ion-skeleton-text animated></ion-skeleton-text>
    </div>
    <div class="leaderboard-cards-title5">
      <ion-skeleton-text animated class="sub"></ion-skeleton-text>
    </div>
    <div class="discover-two-cards-area missions-two-cards-area">
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
    </div>
    <div class="discover-two-cards-area missions-two-cards-area">
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
      <ion-skeleton-text animated class="big-card"></ion-skeleton-text>
    </div>
  </div>
}
<!-- [GF] Skeleton Game leaderboard -->